import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';

import { useFormik } from 'formik';
import { string_required, number } from '../../validation/validationSchema';
import * as Yup from 'yup';
import { addPlan } from '../../api-services';

const initialState = {
  plan_name: '',
  plan_cost: '',
  plan_type: '',
  plan_duration: '',
  free_sms: '',
  free_mins: '',
  plan_comment: '',

  // duration: '',
};

const AddPlan = ({ setOpenModal, openModal, editData = {}, setEditData }) => {
  const isEdit = editData && Object.keys(editData).length > 0;
  const [initialValues, setInitialValues] = useState(initialState);
  const queryClient = useQueryClient();

  const validationSchema = Yup.object({
    plan_name: string_required,
    plan_cost: number,
    plan_type: string_required,
    plan_duration: string_required,
    free_sms: number,
    free_mins: number,
    plan_comment: string_required,
    // duration: number,
  });

  const { isLoading: isLoadingAddMember, mutateAsync: mutateAsync1 } =
    useMutation('addPlan', addPlan, {
      onSuccess: (data) => {
        setOpenModal(false);
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 3000,
        }).then(() => {
          queryClient.invalidateQueries('PlanListing');
          formik.resetForm();
        });
      },
      onError: (error) => {
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });

  const handleSubmitForm = async (values) => {
    await mutateAsync1(values);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: !isEdit && validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const handleClose = () => {
    setOpenModal(false);
    setEditData({});
    formik.resetForm();
  };

  return (
    <Modal
      size="md"
      centered
      show={openModal}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            {isEdit ? 'Edit' : 'Add'} Plan
          </h5>
        </div>

        <div className="modal-body">
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                name="plan_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.plan_name}
              />
              {formik.touched.plan_name && formik.errors.plan_name ? (
                <div className="error_required">{formik.errors.plan_name}</div>
              ) : null}
            </div>
          </div>

          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="number"
                step="any"
                className="form-control"
                placeholder="Plan cost"
                name="plan_cost"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.plan_cost}
              />
              {formik.touched.plan_cost && formik.errors.plan_cost ? (
                <div className="error_required">{formik.errors.plan_cost}</div>
              ) : null}
            </div>
          </div>

          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="plan_type"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.plan_type}
                disabled={isEdit}
              >
                <option value="">Please select plan type</option>
                <option value="P" key="1">
                  Paid
                </option>
                <option value="F" key="2">
                  Free
                </option>
              </select>
              {formik.touched.plan_type && formik.errors.plan_type ? (
                <div className="error_required">{formik.errors.plan_type}</div>
              ) : null}
            </div>
          </div>

          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="plan_duration"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.plan_duration}
                disabled={isEdit}
              >
                <option value="">Please select duration</option>
                <option value="M" key="1">
                  Monthly
                </option>
                <option value="Q" key="2">
                  Quarterly
                </option>
                <option value="H" key="3">
                  Half Yearly
                </option>
                <option value="Y" key="4">
                  Yearly
                </option>
              </select>
              {formik.touched.plan_duration && formik.errors.plan_duration ? (
                <div className="error_required">
                  {formik.errors.plan_duration}
                </div>
              ) : null}
            </div>
          </div>

          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="number"
                step="any"
                className="form-control"
                placeholder="Free SMS"
                name="free_sms"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.free_sms}
              />
              {formik.touched.free_sms && formik.errors.free_sms ? (
                <div className="error_required">{formik.errors.free_sms}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="number"
                step="any"
                className="form-control"
                placeholder="Free Minutes"
                name="free_mins"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.free_mins}
              />
              {formik.touched.free_mins && formik.errors.free_mins ? (
                <div className="error_required">{formik.errors.free_mins}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Comment"
                name="plan_comment"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.plan_comment}
              />
              {formik.touched.plan_comment && formik.errors.plan_comment ? (
                <div className="error_required">
                  {formik.errors.plan_comment}
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleClose()}
          >
            Close
          </button>

          <button type="submit" className="btn btn-dark-blue">
            {isLoadingAddMember ? 'Please Wait...' : 'Submit'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddPlan;
